import * as Icons from "lucide-react";

function getBlock(page, type) {
    return (
        (page?.sections || [])
            .flatMap((section) => section.blocks || [])
            .find((block) => block.type === type)?.data || {}
    );
}

export default function ContactForm({
    page,
    form,
    change,
    submit,
    submitting,
    done,
}) {
    const formContent = getBlock(page, "contact_form");
    return (
        <>
            {done ? (
                <div className="text-center py-10">
                    <div className="w-14 h-14 rounded-full bg-[#EAF4E3] flex items-center justify-center mx-auto text-[#538135] mb-4">
                        <Icons.Send size={22} />
                    </div>

                    <h3 className="font-display text-xl font-semibold text-gray-900">
                        {formContent.success_title}
                    </h3>

                    <p className="text-sm text-gray-600 mt-2">
                        {formContent.success_message}
                    </p>
                </div>
            ) : (
                <>
                    <h2 className="font-display text-2xl font-semibold text-gray-900">
                        {formContent.title}
                    </h2>

                    <p className="mt-2 mb-6 text-sm text-gray-600">
                        {formContent.description}
                    </p>

                    <form onSubmit={submit} data-testid="contact-form">
                        {[
                            ["name", "Full name", "text", true],
                            ["email", "Email", "email", true],
                            ["organization", "Organization", "text", false],
                            ["subject", "Subject", "text", false],
                        ].map(([k, label, type, req]) => (
                            <div key={k} className="mb-4">
                                <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                                    {label}
                                </label>

                                <input
                                    type={type}
                                    required={req}
                                    data-testid={`contact-${k}`}
                                    value={form[k]}
                                    onChange={(e) => change(k, e.target.value)}
                                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#EAF4E3] focus:border-[#538135] transition-colors"
                                />
                            </div>
                        ))}

                        <div className="mb-6">
                            <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                                Message
                            </label>

                            <textarea
                                required
                                rows={5}
                                data-testid="contact-message"
                                value={form.message}
                                onChange={(e) => change("message", e.target.value)}
                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#EAF4E3] focus:border-[#538135] transition-colors"
                            />
                        </div>

                        <button
                            disabled={submitting}
                            data-testid="contact-submit"
                            className="w-full bg-[#006B3C] text-white hover:bg-[#09582D] transition-colors rounded-md px-4 py-3 text-sm font-semibold disabled:opacity-60"
                        >
                            {submitting ? "Sending…" : "Send message"}
                        </button>
                    </form>
                </>
            )}
        </>
    );
}